import { render, staticRenderFns } from "./rewardTrafficPermitLvEdit.vue?vue&type=template&id=62dbc7b1&scoped=true&"
import script from "./rewardTrafficPermitLvEdit.vue?vue&type=script&lang=js&"
export * from "./rewardTrafficPermitLvEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62dbc7b1",
  null
  
)

export default component.exports